/**
 * 项目特征接口
 */
export interface ProjectFeatures {
    frameworks: string[];
    languages: string[];
    tools: string[];
    keywords: string[];
    projectType: string;
    libraries?: string[];
}

/**
 * 工作区文件夹接口（VS Code 兼容）
 */
export interface WorkspaceFolder {
    uri: { fsPath: string };
    name: string;
    index?: number;
}

/**
 * 上下文检测结果
 */
export interface DetectedContext {
    fileType: string;
    imports: string[];
    scenario: string;
    userConfiguredAgents?: string[];
}

/**
 * 规范响应结构
 */
export interface StandardResponse {
    uris?: string[];
    standards?: Array<{
        uri: string;
        name: string;
        description?: string;
        keyRules?: string[];
        content?: string;
    }>;
    projectInfo?: {
        hasUserConfig: boolean;
        userAgents: string[];
        message: string;
    };
    error?: string;
}

/**
 * 健康检查结果
 */
export interface HealthCheckResult {
    status: string;
    details: string[];
}

/**
 * 健康检查集合
 */
export interface HealthChecks {
    server: HealthCheckResult;
    configuration: HealthCheckResult;
    dependencies: HealthCheckResult;
    standards: HealthCheckResult;
    workspace: HealthCheckResult;
}

/**
 * 工具调用参数基础接口
 */
export interface ToolArgsBase {
    workspacePath?: string;
    projectPath?: string;
}

/**
 * 骨架生成参数
 */
export interface SkeletonArgs extends ToolArgsBase {
    referenceProjectPath: string;
    newProjectPath: string;
    newProjectName: string;
    generateDocs?: boolean;
    includeLayers?: string[];
    excludePatterns?: string[];
}

/**
 * 骨架指南结构
 */
export interface SkeletonGuide {
    directories: Array<{
        from: string;
        to: string;
        description: string;
    }>;
    coreUtils: Array<{
        from: string;
        type: string;
        recommended: boolean;
    }>;
    styleFiles: string[];
    configFiles: (string | undefined)[];
    corePages: (string | undefined)[];
}

/**
 * 可分组项接口
 */
export interface GroupableItem {
    [key: string]: unknown;
}

/**
 * Agent 元数据接口
 */
export interface AgentMetadata {
    id: string;
    path: string;
    title: string;
    description: string;
    tags: string[];
    applicableWhen?: {
        frameworks?: string[];
        tools?: string[];
        languages?: string[];
        keywords?: string[];
    };
    score?: number;
}

/**
 * 配置生成结果
 */
export interface GenerationResult {
    success: boolean;
    projectType?: string;
    matchedAgents?: AgentMetadata[];
    configPath?: string;
    error?: string;
}

/**
 * 日志输出接口
 * @deprecated 使用 core/logger.ts 中的 Logger 类
 */
export interface Logger {
    log(message: string): void;
    error(message: string): void;
}

/**
 * 控制台日志实现
 * @deprecated 使用 core/logger.ts 中的 createLogger()
 */
export class ConsoleLogger implements Logger {
    private enableDebug: boolean;

    constructor(enableDebug: boolean = false) {
        this.enableDebug = enableDebug;
    }

    log(message: string): void {
        console.error(`[MCP] [INFO] ${message}`);
    }
    
    error(message: string): void {
        console.error(`[MCP] [ERROR] ${message}`);
    }

    debug(message: string): void {
        if (this.enableDebug) {
            console.error(`[MCP] [DEBUG] ${message}`);
        }
    }
}
